/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

function CheckBoxWrapper(props) {
  const {
    id,
    children,
    label,
    inputRef,
    fieldClass,
    hasError,
    field,
    focused,
    handleBlur,
    handleFocus,
    handleChange,
    error,
    disabled,
    field: { onChange, ...fieldAttrs },
    labelClass,
    ...attrs
  } = props;

  const onHandleChange = (e) => {
    onChange(e);
    if (handleChange) handleChange(e);
  };

  return (
    <>
      {children ? (
        <Form.Check custom id={id} className={fieldClass || undefined} {...attrs}>
          <Form.Check.Input
            ref={inputRef}
            isInvalid={hasError && error}
            onChange={onHandleChange}
            disabled={disabled}
            {...field}
          />
          <Form.Check.Label>{children || label}</Form.Check.Label>
        </Form.Check>
      ) : (
        <Form.Check
          id={id}
          className={fieldClass || undefined}
          onChange={onHandleChange}
          ref={inputRef}
          label={label}
          disabled={disabled}
          isInvalid={hasError && error}
          {...fieldAttrs}
          {...attrs}
        />
      )}
      {hasError && error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
    </>
  );
}

CheckBoxWrapper.propTypes = {
  /**
   * field is required and must be an object
   */
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.object.isRequired,
};

export default CheckBoxWrapper;
